import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import VideoSection from './VideoSection';
import CaseStudySection from './CaseStudySection';
import PricingSection from './PricingSection';
import WhyChooseSection from './WhyChooseSection';
import ContactSection from './ContactSection';
import Footer from './Footer';

const Home = () => (
  <>
    <Helmet>
      <title>Fraud Buster - Home</title>
      <meta
        name="description"
        content="Secure your transactions with Fraud Buster." />
    </Helmet>
    <HeroSection />
    <FeaturesSection />
    <VideoSection />
    <CaseStudySection />
    <PricingSection />
    <WhyChooseSection />
    <ContactSection />
    <Footer />
  </>
);

export default Home;
